import type { TreeDataNode } from 'antd';
import type { TreeItem } from 'components/common/utils/map-items-to-antd-tree-nodes';

export const getParentMap = (treeData: TreeDataNode[]): Record<string, React.Key | null> => {
  const parentMap: Record<string, React.Key | null> = {};

  const traverse = (nodes: TreeDataNode[], parentKey: React.Key | null) => {
    nodes.forEach(node => {
      if (node.key !== undefined) {
        parentMap[String(node.key)] = parentKey;
      }
      if (node.children) {
        traverse(node.children, node.key);
      }
    });
  };

  traverse(treeData, null);

  return parentMap;
};

export const getAncestors = (
  keys: React.Key | React.Key[],
  parentMap: Record<string, React.Key | null>
): React.Key[] => {
  const keysArray = Array.isArray(keys) ? keys : [keys];
  const ancestorsSet = new Set<React.Key>();

  keysArray.forEach(key => {
    let currentKey: React.Key | null = parentMap[String(key)] || null;
    while (currentKey) {
      ancestorsSet.add(currentKey);
      currentKey = parentMap[String(currentKey)] || null;
    }
  });

  return Array.from(ancestorsSet);
};

export const collectDescendants = (treeItems: Record<string, TreeItem>, itemId: string): string[] => {
  const item = treeItems[itemId];
  if (!item?.children?.length) return [];

  return item.children.reduce<string[]>((acc, child) => {
    if (!child) return acc;
    return [...acc, child.id, ...collectDescendants(treeItems, child.id)];
  }, []);
};
